import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import {
  DatabaseError,
  DataIntegrityError,
  OpenSearchError,
} from "../auth/errors";
import { TopicId } from "../ids/definitions";
import {
  TextConciergeConversationDetailResponse,
  TextConciergeConversationListResponse,
  TextConciergeFilterTab,
} from "../models/shopper-ai/conversation/text-concierge";
import { DEFAULT_LIMIT, MAX_LIMIT } from "../schema/pagination";

export const TextConciergeConversationListQueryParams = Schema.Struct({
  limit: Schema.optionalWith(
    Schema.NumberFromString.pipe(
      Schema.int(),
      Schema.positive(),
      Schema.lessThanOrEqualTo(MAX_LIMIT),
    ),
    { default: () => DEFAULT_LIMIT },
  ),
  offset: Schema.optionalWith(
    Schema.NumberFromString.pipe(Schema.int(), Schema.nonNegative()),
    { default: () => 0 },
  ),
  filterTab: Schema.optionalWith(TextConciergeFilterTab, {
    default: () => "all" as const,
  }),
  sortBy: Schema.optionalWith(
    Schema.Literal(
      "lastResponseAt",
      "createdAt",
      "lastCustomerMessageAt",
      "lastMerchantMessageAt",
    ),
    { default: () => "lastResponseAt" as const },
  ),
  sortDirection: Schema.optionalWith(Schema.Literal("asc", "desc"), {
    default: () => "desc" as const,
  }),
});
export type TextConciergeConversationListQueryParams =
  typeof TextConciergeConversationListQueryParams.Type;

export const TextConciergeGroup = HttpApiGroup.make("textConcierge")
  .add(
    endpoint.merchant
      .get("listTextConciergeConversations", "/text-concierge/conversations")
      .setUrlParams(TextConciergeConversationListQueryParams)
      .addSuccess(TextConciergeConversationListResponse)
      .addError(HttpApiError.Forbidden)
      .addError(OpenSearchError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .get(
        "getTextConciergeConversationDetail",
        "/text-concierge/conversations/:topicId",
      )
      .setPath(Schema.Struct({ topicId: TopicId }))
      .addSuccess(TextConciergeConversationDetailResponse)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
